module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myservice"
  }, [_c('Vueheader', {
    attrs: {
      "addActive": _vm.addActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "state"
  }, [_c('p', [_vm._v("当前状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.tjkTaskApplyState),
      callback: function($$v) {
        _vm.tjkTaskApplyState = $$v
      },
      expression: "tjkTaskApplyState"
    }
  }, _vm._l((_vm.taskOptions), function(t) {
    return _c('el-option', {
      key: t.value,
      attrs: {
        "label": t.label,
        "value": t.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('p', [_vm._v("客服")]), _vm._v(" "), _c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.tjkSearch,
      "placeholder": "请输入姓名或登录账号",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.tjkHandleSelect
    },
    model: {
      value: (_vm.tjkName),
      callback: function($$v) {
        _vm.tjkName = $$v
      },
      expression: "tjkName"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchOwnedTjk(1)
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contentList"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.serviceList), function(item, key) {
    return _c('ul', {
      class: {
        'active': key % 2 != 1
      }
    }, [_c('li', {
      staticClass: "name border"
    }, [_vm._v(_vm._s(item.tjkuser.realName))]), _vm._v(" "), _c('li', {
      staticClass: "phone border"
    }, [_vm._v(_vm._s(item.tjkuser.loginName))]), _vm._v(" "), _c('li', {
      staticClass: "joinDate border"
    }, [_vm._v(_vm._s(item.createDate))]), _vm._v(" "), _c('li', {
      staticClass: "currentState border"
    }, [(item.tjkStatus == 'WaitTrained') ? _c('span', [_vm._v("待培训")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'Training') ? _c('span', [_vm._v("培训中")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'ForPost') ? _c('span', [_vm._v("培训完毕待上岗")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'InPost') ? _c('span', [_vm._v("已上岗")]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "workTime border"
    }, [_vm._v(_vm._s(item.workHour) + "H")]), _vm._v(" "), _c('li', {
      staticClass: "handle"
    }, [(item.tjkStatus == 'WaitTrained') ? _c('a', {
      staticClass: "handle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.updateTjkStatus(item.tjkuser.id, 'Training')
        }
      }
    }, [_vm._v("标记开始培训")]) : (item.tjkStatus == 'Training') ? _c('a', {
      staticClass: "handle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.updateTjkStatus(item.tjkuser.id, 'ForPost')
        }
      }
    }, [_vm._v("标记已培训完结")]) : _vm._e()])])
  }), _vm._v(" "), [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serviceList == null || _vm.serviceList.length == 0),
      expression: "serviceList == null || serviceList.length == 0"
    }],
    staticClass: "noRecord"
  }, [_vm._v("暂无记录")])], _vm._v(" "), _c('pagination', {
    attrs: {
      "pages": _vm.pages,
      "pageNum": _vm.pageNum
    },
    on: {
      "getData": _vm.searchOwnedTjk
    }
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "background": "#d1dbe5"
    }
  }, [_c('li', {
    staticClass: "name border"
  }, [_vm._v("客服姓名")]), _vm._v(" "), _c('li', {
    staticClass: "phone border"
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('li', {
    staticClass: "joinDate border"
  }, [_vm._v("注册时间")]), _vm._v(" "), _c('li', {
    staticClass: "currentState border"
  }, [_vm._v("当前状态")]), _vm._v(" "), _c('li', {
    staticClass: "workTime border"
  }, [_vm._v("上岗时长")]), _vm._v(" "), _c('li', {
    staticClass: "handle"
  }, [_vm._v("操作")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51bbc65a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51bbc65a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/myService.vue
// module id = 250
// module chunks = 1